import { Alert } from "../overlays/Alert/Alert";
import styles from "./UIconstants.module.css";
// Rendering helpers
export const NotAvailable = <span className={styles.spanGrey}>N/A</span>;
export const NotSet = <span className={styles.spanGrey}>-</span>;
export const NotAllowed = (
  <Alert type="danger" message={"You don't have permissions to view this page."} fit centered />
);
export const TrashedNotEditable = <Alert type="danger" message={"Trashed entities cannot be edited."} fit centered />;
